import { t } from "i18next";
import React, { Fragment, useContext, useState, useEffect } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../../App";
import GoBackBtn from "../../../components/buttons/GoBackBtn";
import EditPassForm from "../../../components/passes/EditPassForm";
import UserPass from "../../../components/passes/UserPass";
import $ from "jquery";
import moment from "moment";
import { postMethod } from "../../../requests";

const EditUserPass = () => {
    const { showView, setAlerts, goBack, viewsHistory, checkServerData, changeView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [userPass, setUserPass] = useState(showView.params.pass);
    //console.log(showView.params.pass);
    const [loading, setLoading] = useState(true);
    const [passesList, setPassesList] = useState(null);
    const [view, setView] = useState(null);
    const [list, setList] = useState(null);
    const [selectedPassTemplate, setSelectedPassTemplate] = useState(null);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];
        if (!userPass.up_entries || userPass.up_entries.length === 0) {
            $("#passEntries").addClass("is-invalid");
            errors.push(t("error.entriesNumberIsEmpty"));
        } else if (userPass.up_entries < showView.params.pass.up_entries - showView.params.pass.up_entries_left) {
            $("#passEntries").addClass("is-invalid");
            errors.push(t("error.entriesCannotBeLowerThanUsedEntries"));
        } else if (userPass.up_entries === 0 || userPass.up_entries === "0") {
            $("#passEntries").addClass("is-invalid");
            errors.push(t("error.passEntriesCannotBe0"));
        }
        if (!userPass.up_due_date) {
            $("#userPassDueDate").addClass("is-invalid");
            errors.push(t("error.dueDateIsEmpty"));
        } else if (moment(userPass.up_due_date).format("YYYY-MM-DD") < moment(showView.params.pass.up_purchase_date).format("YYYY-MM-DD")) {
            $("#userPassDueDate").addClass("is-invalid");
            errors.push(t("error.dueDateCannotBeLowerThanPurchaseDate"));
        }

        if (!userPass.up_price || userPass.up_price.length === 0) {
            $("#passPrice").addClass("is-invalid");
            errors.push(t("error.passPriceIsEmpty"));
        }
        if (!userPass.up_duration_days || userPass.up_duration_days.length === 0) {
            $("#passDuration").addClass("is-invalid");
            errors.push(t("error.passDurationIsEmpty"));
        } else if (userPass.up_duration_days === 0 || userPass.up_duration_days === "0") {
            $("#passDuration").addClass("is-invalid");
            errors.push(t("error.passDurationCannotBe0"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.editingUserPass") }]);
            setBlockForm(true);
            updateUserPass();
        }
    };

    const updateUserPass = async () => {
        const res = await postMethod("/update-user-pass", { userPass: userPass, oldUserPass: showView.params.pass });
        if (checkServerData(res)) {
            changeView({ nav: "users", sub: "userDetails", params: { userID: userPass.user_id } });
            setAlerts([{ variant: "success", message: t("success.userPassUpdated"), fading: 2000 }]);
        }
    };

    const getPassesList = async () => {
        const res = await postMethod("/passes-list", { onlyActivePasses: true });
        if (checkServerData(res)) {
            //console.log(res.data.list);
            const _list = [];
            res.data.list.forEach((e, i) => {
                if (e.pass_id !== showView.params.pass.pass_id) _list.push({ key: i, value: e.pass_id, text: e.pass_name });
            });
            setList(_list);
            setPassesList(res.data.list);
        }
    };

    useEffect(() => {
        if (view === "changePassToAnother") getPassesList();
        setFormChanged(true);
        // eslint-disable-next-line
    }, [view]);

    useEffect(() => {
        if (selectedPassTemplate) {
            const template = passesList.filter((e) => e.pass_id === selectedPassTemplate)[0];
            setUserPass({
                ...userPass,
                up_entries: template.pass_entries,
                up_price: template.pass_price,
                up_duration_days: template.pass_duration_days,
                up_due_date: template.pass_due_date,
                pass_id: selectedPassTemplate,
            });
        }
        // eslint-disable-next-line
    }, [selectedPassTemplate]);

    useEffect(() => {
        if (loading) {
            if (passesList && list) setLoading(false);
        }
        // eslint-disable-next-line
    }, [passesList, list]);

    return (
        <Fragment>
            <GoBackBtn />

            <Container fluid="lg">
                <Form onSubmit={checkValidation} autoComplete="off">
                    <Row>
                        <Col xs={12} className="">
                            <h1 className="h4 d-inline-block m-0 pt-2 mb-4">{t("passes.editUserPass")}</h1>
                        </Col>
                        <Col xs={12} className="px-4 mb-4">
                            <Row>
                                <Col xs={12} lg={6} className="border shadow-sm rounded px-0">
                                    <Table className="white-table mb-0" borderless>
                                        <tbody>
                                            <tr className="fs-6 text-center">
                                                <td colSpan={3} className="text-start">
                                                    {t("users.student")}: <strong>{userPass.user_name}</strong>
                                                </td>
                                            </tr>
                                            <UserPass pass={showView.params.pass} i={0} onlyDisplay />
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-primary" onClick={() => setView("changePassToAnother")} className="mb-3">
                                {t("passes.changePassToAnother")}
                            </Button>
                        </Col>
                        <Col>
                            <Button variant="outline-primary" onClick={() => setView("editPassData")} className="mb-3">
                                {t("passes.editPassData")}
                            </Button>
                        </Col>
                    </Row>
                    {view === "changePassToAnother" && (
                        <Fragment>
                            {loading ? (
                                <Row>
                                    <Col className="my-3 text-center">
                                        <p className="h5">{t("loadingData")}</p>
                                    </Col>
                                </Row>
                            ) : (
                                <Fragment>
                                    {list && (
                                        <Form.Group>
                                            <Form.Label>{t("passes.changePassFromBelow")}</Form.Label>
                                            <Dropdown
                                                placeholder={t("choose")}
                                                fluid
                                                selection
                                                options={list}
                                                onChange={(e, data) => {
                                                    setSelectedPassTemplate(data.value);
                                                    setFormChanged(true);
                                                }}
                                                value={selectedPassTemplate}
                                                id={"choosePassTemplateDropdown"}
                                                className="mb-3"
                                            />
                                        </Form.Group>
                                    )}
                                    {selectedPassTemplate && <EditPassForm setUserPass={setUserPass} userPass={userPass} setFormChanged={setFormChanged} blockForm={blockForm} />}
                                </Fragment>
                            )}
                        </Fragment>
                    )}

                    {view === "editPassData" && (
                        <Fragment>
                            <EditPassForm setUserPass={setUserPass} userPass={userPass} setFormChanged={setFormChanged} blockForm={blockForm} />
                        </Fragment>
                    )}

                    <Row className="sticky-bottom bg-light-primary" style={{ zIndex: 2 }}>
                        <Col xs={8}>
                            <Button variant="primary" className="my-4" type="submit" disabled={blockForm || !formChanged}>
                                {t("saveChanges")}
                            </Button>
                        </Col>
                        <Col xs={4} className="text-end">
                            {viewsHistory.length > 0 && (
                                <Button variant="outline-secondary" className="my-4" onClick={() => goBack()}>
                                    {t("cancel")}
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Form>{" "}
            </Container>
        </Fragment>
    );
};

export default EditUserPass;
